import { render, staticRenderFns } from "./CtrLandModify.vue?vue&type=template&id=2d6053f3&scoped=true&"
import script from "./CtrLandModify.vue?vue&type=script&lang=js&"
export * from "./CtrLandModify.vue?vue&type=script&lang=js&"
import style0 from "./CtrLandModify.vue?vue&type=style&index=0&id=2d6053f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6053f3",
  null
  
)

export default component.exports